const getLowestSailing = (
  sailings,
  typeRoom = ['INTERIOR'],
  idLowest,
  roomLowest,
) => {
  const listSailings = Array.isArray(sailings) ? [...sailings] : [];
  const expandSailing = [];
  listSailings.forEach(element => {
    const baseObj = {
      bookingLink: element.bookingLink,
      id: element.id,
      groupId: element.groupId,
      sailDate: element.sailDate,
      startDate: element.startDate,
      endDate: element.endDate,
      taxesAndFees: element.taxesAndFees,
      taxesAndFeesIncluded: element.taxesAndFeesIncluded,
    };

    element.stateroomClassPricing.forEach(element => {
      const { price, stateroomClass, uuid } = element;
      if ((!typeRoom || typeRoom?.includes(stateroomClass?.id)) && price) {
        expandSailing.push({
          ...baseObj,
          price: price,
          stateroomClass: stateroomClass,
          priceToSort: price?.value,
          ...(uuid && { uuid }),
        });
      }
    });
  });
  //expandSailing.sort((a, b) => (a.priceToSort > b.priceToSort ? 1 : -1));
  expandSailing.sort((a, b) => a.priceToSort - b.priceToSort);

  const [lowestSailing] = expandSailing;
  if (!lowestSailing) return undefined;

  const mainLowest = expandSailing.find(
    item => item.id == idLowest && roomLowest == typeRoom,
  );

  const result = mainLowest ? mainLowest : lowestSailing;

  return {
    bookingLink: result?.bookingLink,
    id: result?.id,
    groupId: result.groupId,
    sailDate: result?.sailDate,
    startDate: result?.startDate,
    endDate: result?.startDate,
    lowestStateroomClassPrice: {
      price: result?.price,
      stateroomClass: result?.stateroomClass,
      ...(result.uuid && { uuid: result.uuid }),
      __typename: 'StateroomClass',
    },
    taxesAndFees: result?.taxesAndFees,
    taxesAndFeesIncluded: result?.taxesAndFeesIncluded,
  };
};

export default getLowestSailing;
